import React from 'react';
import { FreeBetsWrapper } from '@pascal/pascal-core';
import { CombinationsWrapper } from '../../containers/combinationsWrapper';
import { MobileHeaderSection } from '../../components/mobileHeaderSection';
import { TableCardsSection } from '../../components/tableCardsSection';
import { BetActionWrapper } from '../../containers/betActionWrapper';
import { FooterSectionWrapper } from '../../containers/footerSectionWrapper';

export function MobileGameMain() {
  return (
    <div className='tp-game-mobile-wrapper'>
      <FreeBetsWrapper />
      <MobileHeaderSection />
      <div className='tp-game-mobile-content'>
        <div className='tp-game-mobile-game'>
          <div className='tp-game-mobile-game-inner'>
            <div className='tp-g-mobile-holder'>
              <CombinationsWrapper />
              {/* END top section */}
              <div className='tp-g-mobile-middle'>
                <div className='poker-table'>
                  <TableCardsSection />
                </div>
              </div>
              <BetActionWrapper />
            </div>
          </div>
          <FooterSectionWrapper />
        </div>
      </div>
    </div>
  );
}
